<template>
  <div class="wrapper">
    <div class="top-panel">
      <div class="title">{{ place.name }} - 路网绘制</div>
    </div>
    <div class="container-panel">
      <div class="left-panel">
        <div class="floors-wrapper">
          <div
            class="floor"
            :class="{ active: i.id === floorId }"
            @click="changeFloor(i)"
            v-for="i in place.floors"
            :key="i.id">
            {{ i.name }}
          </div>
        </div>
        <div class="container-wrapper">
          <div class="btns">
            <div class="left">
              <div
                :class="{ active: view === 1 }"
                @click="changeView(1)"
                class="btn">
                选择
              </div>
              <div
                :class="{ active: view === 2 }"
                @click="changeView(2)"
                class="btn">
                添加导航线
              </div>
              <div
                :class="{ active: view === 3 }"
                @click="changeView(3)"
                class="btn">
                添加导航点
              </div>
              <!-- 如果是从地图编辑器来的，那么不允许添加地图点，从svg里面读 -->
              <div
                v-if="!from"
                :class="{ active: view === 4 }"
                @click="changeView(4)"
                class="btn">
                添加地图点
              </div>
              <div
                :class="{ active: view === 5 }"
                @click="changeView(5)"
                class="btn">
                添加自定义区域
              </div>
              <div @click="areaVisibleHandler" class="btn">
                {{ areaVisible ? '隐藏自定义区域' : '显示自定义区域' }}
              </div>
              <div @click="pathVisibleHandler" class="btn">
                {{ pathVisible ? '隐藏车道' : '显示车道' }}
              </div>
            </div>
            <div class="right">
              <el-select
                v-if="poiData.curPoiIndex > -1"
                style="margin-right: 10px"
                size="mini"
                filterable
                clearable
                v-model="poiData.curPoiIndex"
                @change="poiSelectHandler"
                :placeholder="'请选择POI标注'">
                <el-option
                  v-for="(g, i) in poiData.pois"
                  :key="i"
                  :label="g.name"
                  :value="i"/>
              </el-select>
              <div
                @click="doSelectFile()"
                class="btn"
                style="margin-right: 10px">
                导入POI
              </div>
              <div
                @click="doSelectImportFile()"
                class="btn"
                style="margin-right: 10px">
                导入路网
              </div>
              <div @click="saveData()" class="btn">保存</div>
              <div
                class="file"
                style="position: absolute; opacity: 0; visibility: hidden">
                <input ref="file" type="file" @change="fileChange" >
                <input
                  ref="importFile"
                  type="file"
                  @change="fileImportChange">
                <a id="downloadAnchorElem" href="javascript:;">x</a>
              </div>
            </div>
          </div>
          <div class="containers">
            <div
              v-show="viewType === 1 || viewType === 0"
              class="container konva-container"
              :style="{
                width: viewType === 0 ? '50%' : '100%'
              }">
              <img
                v-if="viewType === 0"
                @click="changeViewType(1)"
                class="zoom-btn"
                src="./roadMapComponent/assets/zoom-out.png"
                alt="">
              <img
                v-if="viewType === 1"
                @click="changeViewType(0)"
                class="zoom-btn"
                src="./roadMapComponent/assets/zoom-in.png"
                alt="">
              <div class="c" ref="container"></div>
            </div>
            <div
              v-show="viewType === 2 || viewType === 0"
              class="container owlly-container"
              :style="{
                width: viewType === 0 ? '50%' : '100%'
              }">
              <img
                v-if="viewType === 0"
                @click="changeViewType(2)"
                class="zoom-btn"
                src="./roadMapComponent/assets/zoom-out.png"
                alt="">
              <img
                v-if="viewType === 2"
                @click="changeViewType(0)"
                class="zoom-btn"
                src="./roadMapComponent/assets/zoom-in.png"
                alt="">
              <div class="c" ref="owllyContainer"></div>
            </div>
          </div>
        </div>
      </div>
      <div class="form-panel">
        <div>视角FOV<input style="width:80px;border-radius: 4px;outline: none;" v-model.number="sceeen_fov"></div>
        <div style="margin-bottom:16px"><input style="width:80px;border-radius: 4px;outline: none;" v-model="pointId"> <el-button size="mini" @click="queryPoint()" style="width:90px;">图形ID查询</el-button></div>
        <div v-if="point.x">x: {{ point.x }}</div>
        <div v-if="point.y">y: {{ point.y }}</div>
        <self-form
          :shape="target"
          :shapeType="targetType"
          @change="onValueChanged"/>
        <div v-if="showDelete" class="btn" @click="deleteGraphic">删除</div>
        <div
          @click="getMockData"
          v-if="showDelete && target.property.screen_end"
          class="btn">
          VR初始化预览
        </div>
      </div>
    </div>

    <el-dialog
      title="导出数据预览"
      :visible.sync="jsonViewerVisible"
      width="40%">
      <json-viewer
        theme="my-awesome-json-theme"
        copyable
        :value="labelingResults"></json-viewer>
    </el-dialog>

    <el-dialog
      title="导入数据预览"
      :visible.sync="importDataViewerVisible"
      @closed="importDialogClosed"
      width="50%">
      <div class="tip-title">
        点击确定导入后，会清理原来显示的数据，加载显示导入的数据，再次点击保存后，才会覆盖服务端保存的数据
        <button @click="sureImportData()">确定导入</button>
      </div>
      <json-viewer
        theme="my-awesome-json-theme"
        copyable
        :value="importLabelingData"></json-viewer>
    </el-dialog>
    <el-dialog
      title="VR预览"
      :visible.sync="vrViewVisible"
      :destroy-on-close="false"
      @closed="vr_viewCloce()"
      :close-on-click-modal="false"
      width="50%">
      <div style="height: 400px" ref="vrViewContainer"></div>
      <div slot="footer" class="dialog-footer">
        <!-- <el-input placeholder="大屏全景id"
                  style="width:120px;float:left"
                  size="small"
                  v-model="view_pan_id" /> -->
        <el-button size="small" type="success" @click="setScreenDirection">设置大屏朝向</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex';
import _, { floor, upperCase } from 'lodash';
import axios from 'axios';
import { vec4, mat4 } from 'gl-matrix';
import JsonViewer from 'vue-json-viewer';
import { SvgUtils, THREE, Shape, ShapeUtils } from '@aibee/owlly';
import { Loading } from 'element-ui';
import { uuid2 as uuid, formatDate } from '@/utils';
import request from '@/utils/request';
import Util from './roadMapComponent/util';

import { KonvaStage, VIEW } from './roadMapComponent/konvaStage';
import convertData from '@/components/mapComponents/convertData';
import { queryAllPois } from '@/api/map';
import Graphic from './roadMapComponent/graphic';
import OwllyStage from './roadMapComponent/owllyStage';
import Point from './roadMapComponent/point';
import SelfForm from './roadMapComponent/form.vue';
import * as arrowImg from '../../assets/image/arrow.png';
import Worker from './roadMapComponent/findPath.worker';

const URL_ROOT = 'https://vr.aibee.cn';
const SECRET = 'secret=U4LOTsSWEASOCXNl4lzyg0rOyGztm1so';

function getPositionTransform(
  [x, y],
  m,
) {
  const alignMat = mat4.fromValues(
    m[0], m[1], m[2], m[3], m[4], m[5], m[6], m[7], m[8], m[9], m[10], m[11], m[12], m[13], m[14], m[15],
  );
  const v = vec4.create();
  vec4.set(v, x, y, 0, 1);
  const result = vec4.create();
  vec4.transformMat4(result, v, alignMat);
  return { x: result[0], y: result[1] };
}
function generateStepsFromPath(path) {
  const commands = path.match(/([MLCmlc](?:(?:-?\d+(?:\.\d+)?(?:[eE]\d+)?)(?:,-?\d+(?:\.\d+)?(?:[eE]\d+)?)+))/g);
  if (!commands) { return []; }
  return commands.map((command) => {
    const c = command[0].toLowerCase();
    const coordStrings = command.slice(1).split(',');
    const coordCount = coordStrings.length;
    const coords = [];
    for (let i = 0; i < coordCount; i += 2) {
      coords.push([
        parseFloat(coordStrings[i]),
        parseFloat(coordStrings[i + 1]),
      ]);
    }
    return { command: c, coords };
  });
}

function generatePathFromSteps(steps) {
  return steps.map((_a) => {
    const command = _a.command; const
      coords = _a.coords;
    return (`${command}${coords.flat(2).join(',')}`);
  }).join('');
}
function generateGroupFromPath(path, trans) {
  const steps = generateStepsFromPath(path);
  const i = 0;
  const ss = steps.map((step) => {
    const crds = step.coords.map((v) => {
      const c = getPositionTransform(v, trans);
      return [c.x, c.y];
    });
    step.coords = crds;
    step.command = upperCase(step.command);
    return step;
  });
  // while (i < steps.length) {
  //   const step = steps[i];

  // const innerL = inner.length;
  // if (i === 0) {
  //   outer.push(step);
  // } else if (i > 0 && step.command !== 'm' && innerL === 0) {
  //   outer.push(step);
  // } else if (i > 0 && step.command === 'm') {
  //   // innerL++;
  //   inner[innerL] = [];
  //   inner[innerL].push(step);
  // } else if (i > 0 && innerL > 0 && step.command !== 'm') {
  //   // console.log('inner', inner, innerL)
  //   inner[innerL - 1].push(step);
  // }
  //   i++;
  // }
  return ss;
}

function distance(p1, p2) {
  const lx = (p1.x - p2.x) ** 2;
  const ly = (p1.y - p2.y) ** 2;
  return lx + ly;
}


export default {
  components: {
    SelfForm,
    JsonViewer,
  },
  computed: {
    floorId() {
      return parseInt(this.$route.query.floor_id, 10);
    },
    placeId() {
      return this.$route.query.place_id;
    },
    showDelete() {
      if (this.target && this.targetType === 'graphic') {
        // if (this.target.group_type === 'BlockPoint') return false;
        // 不是全景点
        if (this.target.property && this.target.property.type !== '91') {
          return true;
        }
      }
      return false;
    },
  },
  watch: {
  },
  data() {
    return {
      sceeen_fov: 120,
      point: {},
      view: 1,
      viewType: 1,
      isPoi: false,
      target: null,
      jsonViewerVisible: false,
      importDataViewerVisible: false,
      targetType: null,
      place: {},
      importLabelingData: {},
      labelingResults: {},
      isVR: false,
      v_blockmark: '',
      v_new_roadnetwork: '',
      shapes: null,
      poiData: {
        pois: [],
        curPoiIndex: -1,
      },
      panoramaList: [],
      areaVisible: true,
      pathVisible: true,
      pointClickTimer: 0,
      dragDelay: 200,
      vrViewVisible: false,
      viewVrData: {},
      viewVRInit: false,
      vrViewStage: null,
      from: null,
      view_pan_id: '', // 视角绑定全景点
      pointId: '', // 点位id
    };
  },
  methods: {
    ...mapActions(['getFloorInfoInit']),
    async init() {
      const res = await this.getFloorInfoInit({ place_id: this.placeId });
      const place = res.find(i => i.id === parseInt(this.placeId, 10));
      const floor = place.floors.find(i => i.id === parseInt(this.floorId, 10));
      this.place = place;
      this.floor = floor;
      this.from = this.$route.query.from;
      this.cmapAlignParam = JSON.parse(floor.floor_cmap_align_param);
      this.isVR = !!this.floor.vr_id;

      const checkDataFloor = this.$route.query.checkDataFloor;
      if (checkDataFloor) {
        this.checkDataFloors(place.floors);
        return;
      }

      if (this.isVR) {
        this.radius = SvgUtils.getRotateRadiusToNorth(this.cmapAlignParam.transformMatrices.upTrans);
      }
      this.northDegrees = this.radius * (180 / Math.PI);

      await this.initPanoData();
      await this.initKonvaStage();
      this.initOwllyStage();
    },
    async checkDataFloors(floors) {
      for (let i = 0; i < floors.length; i++) {
        // eslint-disable-next-line no-await-in-loop
        const rs = await request({
          url: '/deployment-service/new_roadnetwork/labeling_result',
          get: 'get',
          params: {
            floor_id: floors[i].id,
            place_id: this.placeId,
          },
        });
        if (rs.data && rs.data[0].new_labeling_results) {
          const gs = rs.data[0].new_labeling_results;

          gs.graphic_list.forEach((q) => {
            if (q.property) {
              if (typeof q.property.pano_id === 'string') {
                q.property.pano_id = parseInt(q.property.pano_id, 10);
                // eslint-disable-next-line no-restricted-globals
                if (isNaN(q.property.pano_id)) {
                  delete q.property.pano_id;
                }
              }
              if (typeof q.property.block_id === 'number') {
                q.property.block_id = `${q.property.block_id}`;
              }
            }
          });

          // eslint-disable-next-line no-await-in-loop
          const res = await request({
            url: '/deployment-service/new_roadnetwork/post_labeling_result',
            method: 'post',
            data: {
              floor_id: floors[i].id,
              place_id: this.placeId,
              result: gs,
              version: rs.data[0].version,
            },
          });
          // 初始化版本号
          this.v_new_roadnetwork = res.data.version;
        }
      }
    },
    poiSelectHandler() {
      this.konvaStage.clearPois();
      this.konvaStage.loadPois(_.cloneDeep(this.poiData.pois[this.poiData.curPoiIndex].data));
    },
    importDialogClosed() {
      this.importDataViewerVisible = false;
    },
    doSelectFile() {
      this.$refs.file.click();
    },
    doSelectImportFile() {
      this.$refs.importFile.click();
    },
    fileImportChange(e) {
      this.isPoi = false;
      const selectedFile = e.target.files[0];
      if (!selectedFile) {
        this.importLabelingData = {};
        return;
      }
      const reader = new FileReader();
      reader.readAsText(selectedFile);
      const self = this;
      // eslint-disable-next-line func-names
      reader.onload = function () {
        try {
          const json = JSON.parse(this.result);
          self.importLabelingData = json;
          self.importDataViewerVisible = true;
        } catch (ex) {
          self.$message({
            type: 'error',
            message: '不是json文件或者json格式错误',
          });
        }
      };
    },
    fileChange(e) {
      this.isPoi = true;
      const selectedFile = e.target.files[0];
      if (!selectedFile) {
        this.importLabelingData = {};
        return;
      }
      const reader = new FileReader();
      reader.readAsText(selectedFile);
      const self = this;
      // eslint-disable-next-line func-names
      reader.onload = function () {
        try {
          const json = JSON.parse(this.result);
          self.importLabelingData = json;
          self.importDataViewerVisible = true;
        } catch (ex) {
          self.$message({
            type: 'error',
            message: '不是json文件或者json格式错误',
          });
        }
      };
    },
    render3DPath(hideDatas = []) {
      if (!this.currentPano) return;
      const { point_dict, graphic_list } = this.konvaStage.exportData();
      const lines = graphic_list.filter(d => d.graphic_type === 'line');
      const hideLines = hideDatas.filter(d => d.graphic_type === 'line');

      this.owllyStage.clearPaths();
      lines.forEach((l) => {
        if (hideLines.find(hideLine => hideLine.graphic_id === l.graphic_id)) return;
        const from = point_dict[l.graphic_data[0]];
        const to = point_dict[l.graphic_data[1]];
        if (distance(from, this.currentPano) > 100000 && distance(to, this.currentPano) > 100000) return;
        const f = getPositionTransform([from.x, from.y], this.cmapAlignParam.transformMatrices.upTrans);
        const t = getPositionTransform([to.x, to.y], this.cmapAlignParam.transformMatrices.upTrans);
        this.owllyStage.addPath([
          [f.x, f.y, -1.2],
          [t.x, t.y, -1.2],
        ]);
      });
    },
    renderDragging3DPath(graphics) {
      if (!this.currentPano) return;
      const data = graphics;
      const { point_dict, graphic_list } = data;
      const lines = graphic_list.filter(d => d.graphic_type === 'line');

      this.owllyStage.clearDraggingPaths();
      lines.forEach((l) => {
        const from = point_dict[l.graphic_data[0]];
        const to = point_dict[l.graphic_data[1]];
        if (distance(from, this.currentPano) > 100000 && distance(to, this.currentPano) > 100000) return;
        const f = getPositionTransform([from.x, from.y], this.cmapAlignParam.transformMatrices.upTrans);
        const t = getPositionTransform([to.x, to.y], this.cmapAlignParam.transformMatrices.upTrans);
        this.owllyStage.addDraggingPaths([
          [f.x, f.y, -1.2],
          [t.x, t.y, -1.2],
        ]);
      });
    },
    sureImportData() {
      if (this.isPoi) {
        // 导入的是POI
        this.importDataViewerVisible = false;
        this.konvaStage.clearPois();

        const date = new Date();
        const pois = this.transformPoiPositions(this.importLabelingData);
        this.poiData.pois.push({
          name: `POI-${formatDate(date, 'yyyyMMdd')}-${this.poiData.pois.length}`,
          data: pois,
        });
        this.poiData.curPoiIndex = this.poiData.pois.length - 1;
        this.konvaStage.loadPois(_.cloneDeep(pois));
      } else {
        // 导入路网
        this.importDataViewerVisible = false;

        request({
          url: '/deployment-service/new_roadnetwork/post_labeling_result',
          method: 'post',
          data: {
            floor_id: this.floorId,
            place_id: this.placeId,
            result: this.importLabelingData,
            version: this.v_new_roadnetwork,
          },
        }).then((rs) => {
          if (rs.error_no === 0) {
            // 初始化版本号
            this.v_new_roadnetwork = rs.data.version;
            window.location.reload();
          }
        });
      }
    },
    async initOwllyStage() {
      if (!this.floor.vr_id) return;
      this.owllyStage = new OwllyStage({
        container: this.$refs.owllyContainer,
        vrId: this.floor.vr_id,
        panoramaList: this.panoramaList,
        modelPath: this.modelPath,
        initialView: this.initialView,
        listeners: {
          onMoveToPanorama: (pid) => {
            const p = this.panoramaList.find(g => g.id === pid);
            this.currentPano = p;
            if (!this.konvaStage) return;
            this.konvaStage.updateUserPoint({
              x: p.x,
              y: p.y,
            });
            this.render3DPath();
          },
          onPanoramaCameraChanged: (p) => {
            const euler = new THREE.Euler();
            euler.setFromQuaternion(p, 'ZYX');
            const radians = euler.z > 0 ?
              euler.z :
              (2 * Math.PI) + euler.z;
            const deg = THREE.Math.radToDeg(radians);
            this.konvaStage.updateUserPoint({
              rotation: this.northDegrees - deg,
            });
          },
        },
      });

      await this.owllyStage.init();
    },
    orgSteps(steps) {
      // [...{command, coords}] 转换
      const sData = [];
      steps.forEach(({ command, coords }, i) => {
        let ele = [];
        if (command === 'M') {
          if (i !== 0) sData.push(['Z']);
          ele = ['M', ..._.flatten(coords)];
          sData.push(ele);
        } else if (command === 'L') {
          ele = ['L', ..._.flatten(coords)];
          sData.push(ele);
        } else if (command === 'C') {
          ele = ['C', ..._.flatten(coords)];
          sData.push(ele);
        }
      });
      sData.push(['Z']);
      return sData;
    },
    // orgShapeData(downTrans) {
    //   // const shapps = shapes;
    //   // const svgAlignParam = JSON.parse(floor.floor_cmap_align_param);
    //   // const downTrans = svgAlignParam.transformMatrices.downTrans;
    //   const sps = this.shapes.map((s, i) => {
    //     const steps = generateGroupFromPath(s.path, downTrans); // 有inner 和 outer
    //     const d = generatePathFromSteps(steps);
    //     const orgedS = this.orgSteps(steps);
    //     const ts = s.parentName === 'ground' ? [] : Util.transformSegments(orgedS);
    //     s['stroke-width'] = s.strokeWidth;
    //     s.isStore = s.parentName === 'store';
    //     // console.log('----s', s, s.id, s.tag, s.parentName);
    //     s.name = s.tag;
    //     // s.s = s.parentName === 'ground' ? [] : Util.transformSegments(orgedS);
    //     return {
    //       ...s,
    //       // 'stroke-width': 10,
    //       d,
    //       s: ts,
    //     };
    //   });
    //   return sps;
    // },
    async initKonvaStage() {
      console.log('initKonvaStageinitKonvaStage');
      const { floor } = this;
      const params = JSON.parse(floor.floor_cmap_align_param);
      // const blocksUrl = floor.floor_cmap_json;
      // if (blocksUrl) {
        // const { data } = await axios.get(blocksUrl);
        // this.shapes = data;
        // console.log('this.shapes', blocksUrl, this.shapes);
      // }
      const position = new THREE.Vector3();
      const scale = new THREE.Vector3();
      const quaternion = new THREE.Quaternion();
      let panoramaWidth = 0;
      if (this.isVR) {
        new THREE.Matrix4().fromArray(params.transformMatrices.upTrans).decompose(position, quaternion, scale);
        const nscale = scale.x;
        panoramaWidth = 4 / nscale;
      }

      const svgAlignParam = JSON.parse(floor.floor_cmap_align_param);
      // shapes1.steps[0] command 和 coords coords有多个[n,n]
      const downTrans = svgAlignParam.transformMatrices.downTrans;
      const sps = null;
      // if (this.shapes && this.shapes.length) {
        // sps = this.orgShapeData(downTrans);
      // }
      // debugger;

      await this.initLabelResults();
      this.konvaStage = new KonvaStage({
        container: this.$refs.container,
        svgPath: floor.floor_cmap,
        svgAlignParam: JSON.parse(floor.floor_cmap_align_param),
        // shapes: sps,
        config: {
          panorama: {
            width: panoramaWidth,
          },
        },
        listeners: {
          errorHandler: (err) => {
            this.$message({
              type: 'error',
              message: err,
            });
          },
          pointDragStart: (e, type, changeDatas) => {
            this.target = e;
            this.targetType = type;
            this.render3DPath(changeDatas.graphic_list);
          },
          pointClick: (e, type, point) => {
            const now = Date.now();
            if ((now - this.pointClickTimer) > this.dragDelay) {
              this.pointClickTimer = now;
              if (point) {
                const f = getPositionTransform([point.x, point.y], this.cmapAlignParam.transformMatrices.upTrans);
                this.point = f;
              }
              this.target = e;
              this.targetType = type;
            }
            if (type === 'graphic' && e.property.type === '91') {
              this.owllyStage.moveToPanorama(e.property.pano_id);
            }
          },
          blockClick: (e, type) => {
            this.target = e;
            this.targetType = type;
            this.point = {};
          },
          graphicChanged: (g) => {
            const { graphic_list } = g;
            if (Array.isArray(graphic_list)) {
              this.renderDragging3DPath(g);
            }
          },
          changeView: (view) => {
            if (view === 'selection') {
              this.view = 1;
            }
          },
        },
      });
      this.konvaStage.changeView(VIEW.SELECTION);
      this.initPois();
      this.konvaStage.updateUserPoint({
        visible: true,
      });
    },
    async initLabelResults() {
      const params = {
        floor_id: this.floorId,
        place_id: this.placeId,
      };
      const rs = await request({
        url: '/deployment-service/new_roadnetwork/labeling_result',
        get: 'get',
        params,
      });
      // 初始化版本号
      this.v_new_roadnetwork = rs.data[0] && rs.data[0].version;
      const rs1 = await request({
        url: '/deployment-service/blockmarker/labeling_result',
        get: 'get',
        params,
      });

      let labelingResults = {
        graphic_list: [],
        point_dict: {},
        image_url: '',
        poiData: {
          pois: [],
          curPoiIndex: -1,
        },
      };
      if (rs.data.length && rs.data[0].new_labeling_results) {
        labelingResults = rs.data[0].new_labeling_results;
      }

      // 过滤掉垃圾数据（line开始和结束点id一样的）
      // eslint-disable-next-line eqeqeq
      labelingResults.graphic_list = labelingResults.graphic_list.filter(t => t.group_type !== 'PanoramaPoint' && !(t.graphic_type == 'line' && t.graphic_data.length == 2 && t.graphic_data[0] == t.graphic_data[1]));
      // 将原来type=pano和model转换为数字
      labelingResults.graphic_list.forEach((item) => {
        // 转换车位类型
        if (this.transData && item.graphic_type === 'point' && item.property && item.property.type === '0' && new RegExp(`^[${this.transData}]{1}\\d+$`).test(item.property.name)) {
          item.property.type = '15';
        }
        if (item.graphic_type === 'point' && item.property && item.property.type === 'pano') {
          item.property.type = '91';
        }
        if (item.graphic_type === 'point' && item.property && item.property.type === 'model') {
          item.property.type = '92';
        }
      });
      labelingResults = convertData(labelingResults);
      // 大屏朝向点绑定
      labelingResults.graphic_list.forEach((e) => {
        if (e.graphic_type === 'point') {
          if (e.property.screen_direction) {
            const dir = e.property.screen_direction.split(';');
            if (dir.length === 3) {
              e.property.screen_direction_pos = dir.join(';');
            } else if (dir.length === 4) {
              e.property.screen_direction_pos = `${dir[0]};${dir[1]};${dir[2]}`;
              e.property.screen_direction_pid = `${dir[3]}`;
            }
          }
        }
      });
      console.log(labelingResults);

      labelingResults = this.addPanoData(labelingResults, this.panoramaList);
      this.labelingResults = labelingResults;

      const loading = Loading.service({
        fullscreen: true,
        text: '路网加载中...',
      });
      console.time('路网加载时间');
      setTimeout(() => {
        this.konvaStage.loadGraphics(labelingResults);
        loading.close();
        console.timeEnd('路网加载时间');
      }, 500);
    },
    initPois() {
      if (this.labelingResults.poiData && this.labelingResults.poiData.curPoiIndex > -1) {
        this.poiData = _.cloneDeep(this.labelingResults.poiData);
        if (!this.poiData.curPoiIndex) {
          this.poiData.curPoiIndex = this.poiData.pois.length - 1;
        }
        if (this.poiData.curPoiIndex > -1) {
          this.konvaStage.loadPois(_.cloneDeep(this.poiData.pois[this.poiData.curPoiIndex].data));
        }
      }
    },
    transformPoiPositions(data) {
      const pois = [];
      data.forEach((d) => {
        const f = getPositionTransform([d.position.x, d.position.y], this.cmapAlignParam.transformMatrices.downTrans);
        d.position.x = f.x;
        d.position.y = f.y;
        pois.push(d);
      });

      return pois;
    },
    // 获取全景点位
    async initPanoData() {
      if (!this.isVR) return;
      const {
        data: {
          data: {
            modelPath,
            panorama_list: panoramaList,
            initial_view: initialView,
          },
        },
      } = await axios({
        url: `${URL_ROOT}/v1/list-panoramas?${SECRET}`,
        method: 'POST',
        data: {
          store_id: this.floor.vr_id,
        },
      });

      const trans = this.cmapAlignParam.transformMatrices.downTrans;

      for (let i = panoramaList.length - 1; i >= 0; i--) {
        const neighbourPanoramaIDs = panoramaList[i].visible_panorama_seq_ids.map(
          value => panoramaList[value] && panoramaList[value].id,
        );
        panoramaList[i].neighbourPanoramaIDs = neighbourPanoramaIDs;
        const { x, y } = getPositionTransform([panoramaList[i].coordinate.position_x, panoramaList[i].coordinate.position_y], trans);
        panoramaList[i].x = x;
        panoramaList[i].y = y;
      }

      this.panoramaList = panoramaList;
      this.modelPath = modelPath;
      this.initialView = initialView;
    },
    // 删除图形
    async deleteGraphic() {
      if (!this.target) return;

      await this.$confirm('此操作将永久删除图形, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      });

      if (this.target.group_type === 'BlockPoint') {
        await this.$confirm('你正在删除的是一个地图点，删除地图点将导致客户绑定在此地图点上的数据全部失效，请先在业务系统中完成数据解绑，你确定继续吗?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'error',
        });
      }

      this.konvaStage.deleteGraphic(this.target.graphic_id);
      this.target = null;
      this.targetType = null;
    },
    // 功能切换
    changeView(view) {
      if (this.view === view) {
        return;
      }
      this.view = view;
      if (view === 1) {
        this.konvaStage.changeView(VIEW.SELECTION);
      }
      if (view === 2) {
        // 添加导航线
        this.konvaStage.changeView(VIEW.PATH);
      }
      if (view === 3) {
        this.konvaStage.changeView(VIEW.POINT);
      }
      if (view === 4) {
        this.konvaStage.changeView(VIEW.BLOCKPOINT);
      }
      if (view === 5) {
        this.areaVisible = true;
        this.konvaStage.changeView(VIEW.SELFAREA);
      }
    },
    areaVisibleHandler() {
      this.konvaStage.layerVisible('areaLayer', !this.areaVisible);
      this.areaVisible = !this.areaVisible;
    },
    pathVisibleHandler() {
      this.konvaStage.elementVisible('path_direction', !this.pathVisible);
      this.pathVisible = !this.pathVisible;
    },
    saveData() {
      this.changeView(1);

      const labelingResults = this.konvaStage.exportData();
      this.labelingResults = convertData(labelingResults);
      // 商铺block_id 校验
      const storeList = this.labelingResults.graphic_list.filter(g => g.graphic_type === 'point' && g.property.type === '1' && !g.property.block_id);
      if (storeList.length) {
        this.$message({
          type: 'error',
          message: '商铺未关联块ID,请检查绑定',
        });
        this.konvaStage.drawErrorPoints(storeList.map(i => i.graphic_id));
        return false;
      }
      // 车位block_id 校验
      const parkingList = this.labelingResults.graphic_list.filter(g => g.graphic_type === 'point' && g.property.type === '15' && !g.property.block_id);
      if (parkingList.length) {
        this.$message({
          type: 'error',
          message: '车位未关联块ID,请检查绑',
        });
        this.konvaStage.drawErrorPoints(parkingList.map(i => i.graphic_id));
        return false;
      }
      // 视角点校验
      const dirList = this.labelingResults.graphic_list.filter((g) => {
        if (g.graphic_type === 'point' && g.property.screen_direction_pos) {
          const item = g.property.screen_direction_pos.split(';');
          if (item.length < 2) return g;
          // eslint-disable-next-line no-restricted-globals
          if (isNaN(Number(item[0])) || isNaN(Number(item[1])) || isNaN(Number(item[2]))) return g;
          // eslint-disable-next-line no-restricted-globals
          // if (item[3] && isNaN(Number(item[3]))) return g;
        }
      });
      if (dirList.length) {
        this.$message({
          type: 'error',
          message: '朝向点输入格式错误,请检查绑, 绑定格式：[x;y;z]或[x;y;z;panid]',
        });
        this.konvaStage.drawErrorPoints(dirList.map(i => i.graphic_id));
        return false;
      }
      // const floorName = `${this.floor.floor.trim()}`;
      // this.labelingResults.graphic_list.forEach((i) => {
      //   if (i.graphic_id && i.graphic_id.indexOf(floorName) === 0) {
      //     i.graphic_id = i.graphic_id.replace(floorName, '');
      //   }
      //   if (i.group_id && i.group_id.indexOf(floorName) === 0) {
      //     i.group_id = i.group_id.replace(floorName, '');
      //   }
      //   if (i.graphic_data) {
      //     i.graphic_data = i.graphic_data.map((j) => {
      //       if (j.indexOf(floorName) === 0) {
      //         return j.replace(floorName, '');
      //       }
      //       return j;
      //     });
      //   }
      // });

      // const tmpPointDict = {};
      // Object.entries(this.labelingResults.point_dict).forEach((key) => {
      //   if (key[0].indexOf(floorName) === 0) {
      //     key[0] = key[0].replace(floorName, '');
      //     key[1].uuid = key[1].uuid.replace(floorName, '');
      //   }
      //   tmpPointDict[key[0]] = key[1];
      // });
      // this.labelingResults.point_dict = tmpPointDict;

      this.jsonViewerVisible = true;

      this.labelingResults.poiData = this.poiData;

      // 校验线段
      const lList = this.labelingResults.graphic_list.filter(g => g.graphic_type === 'line');
      let hasErrorPath = false;
      const pathIds = [];
      for (let i = 0; i < lList.length; i++) {
        const p1id = lList[i].graphic_data[0];
        const p2id = lList[i].graphic_data[1];
        if (
          !this.labelingResults.graphic_list.find(g => g.graphic_type === 'point' && g.graphic_id === p1id) ||
          !this.labelingResults.graphic_list.find(g => g.graphic_type === 'point' && g.graphic_id === p2id)
        ) {
          hasErrorPath = true;
          pathIds.push(lList[i].graphic_id);
        }
      }

      if (hasErrorPath) {
        this.konvaStage.drawErrorPaths(pathIds);
        this.$message({
          type: 'error',
          message: '发现错误路径，请修复',
        });

        return;
      }

      // 校验重叠点位
      const gList = this.labelingResults.graphic_list.filter(g => g.graphic_type === 'point');
      const pointDict = this.labelingResults.point_dict;
      const duplicateArr = [];
      const ids = [];
      for (let i = 0; i < gList.length; i++) {
        for (let j = i + 1; j < gList.length; j++) {
          if (
            pointDict[gList[i].graphic_id].x === pointDict[gList[j].graphic_id].x &&
            pointDict[gList[i].graphic_id].y === pointDict[gList[j].graphic_id].y
          ) {
            ids.push(gList[i].graphic_id);
            ids.push(gList[j].graphic_id);
            duplicateArr.push([gList[i].graphic_id, gList[j].graphic_id]);
          }
        }
      }
      this.konvaStage.drawErrorPoints(ids);
      if (duplicateArr.length) {
        this.$message({
          type: 'error',
          message: `发现重叠点位，请检查，【${duplicateArr.join(',')}】`,
        });
        return;
      }

      // 校验有block_id的点，必须选择类型
      const emptyTypePoints = gList.filter(g => g.property.block_id && g.property.type === '0');
      if (emptyTypePoints.length) {
        emptyTypePoints.forEach((t) => {
          ids.push(t.graphic_id);
        });
        this.konvaStage.drawErrorPoints(ids);
        this.$message({
          type: 'error',
          message: '发现已标注BlockId的点位，未进行类型选择，请检查',
        });
        return;
      }

      const blockPoints = _.cloneDeep(this.labelingResults.graphic_list.filter(l => l.graphic_type === 'blockPoint'));
      const blocks = this.konvaStage.exportBlockData();

      // 如果与模型对齐过
      blockPoints.map((b) => {
        const p = this.labelingResults.point_dict[b.graphic_data[0]];
        b.center_x_2d = p.x;
        b.center_y_2d = p.y;
        const t = getPositionTransform([p.x, p.y], this.cmapAlignParam.transformMatrices.upTrans);
        b.center_x_3d = t.x;
        b.center_y_3d = t.y;
        return b;
      });

      blocks.map((b) => {
        const t = getPositionTransform([b.center_x_2d, b.center_y_2d], this.cmapAlignParam.transformMatrices.upTrans);
        b.center_x_3d = t.x;
        b.center_y_3d = t.y;
        return b;
      });

      const destPoints = this.labelingResults.graphic_list.filter(g => g.property.block_id);

      this.labelingResults.graphic_list.forEach((q) => {
        q.property.screen_direction = '';
        if (q.graphic_type === 'point' && q.property.screen_direction_pos && !q.property.screen_direction_pid) {
          q.property.screen_direction = q.property.screen_direction_pos;
        } else if (q.graphic_type === 'point' && q.property.screen_direction_pos && q.property.screen_direction_pid) {
          q.property.screen_direction = `${q.property.screen_direction_pos};${q.property.screen_direction_pid}`;
        }
        if (q.property) {
          if (typeof q.property.pano_id === 'string') {
            q.property.pano_id = parseInt(q.property.pano_id, 10);
            // eslint-disable-next-line no-restricted-globals
            if (isNaN(q.property.pano_id)) {
              delete q.property.pano_id;
            }
          }
        }
      });

      request({
        url: '/deployment-service/new_roadnetwork/post_labeling_result',
        method: 'post',
        data: {
          floor_id: this.floorId,
          place_id: this.placeId,
          result: this.labelingResults,
          version: this.v_new_roadnetwork,
        },
      }).then((rs) => {
        if (rs.error_no === 0) {
          const dataStr = `data:text/json;charset=utf-8,${encodeURIComponent(JSON.stringify(this.labelingResults))}`;
          const dlAnchorElem = document.getElementById('downloadAnchorElem');
          const date = new Date();

          dlAnchorElem.setAttribute('href', dataStr);
          dlAnchorElem.setAttribute('download', `路网-${this.floorId}-${formatDate(date, 'yyyyMMdd')}.json`);
          dlAnchorElem.click();
          // 初始化版本号
          this.v_new_roadnetwork = rs.data.version;

          request({
            url: '/deployment-service/blockmarker/post_labeling_result',
            method: 'post',
            data: {
              floor_id: this.floorId,
              place_id: this.placeId,
              result: {
                blockPoints,
                blocks,
                destPoints,
              },
            },
          }).then((rs2) => {
            if (rs2.error_no === 0) {
              this.$message({ type: 'success', message: '保存成功' });
            }
          });
        }
      });
    },
    changeViewType(type) {
      setTimeout(() => {
        this.owllyStage.resize();
        this.konvaStage.resize();
      }, 0);
      this.viewType = type;
    },
    addPanoData(labelResults, panoramaList) {
      if (!this.isVR) return labelResults;
      const trans = this.cmapAlignParam.transformMatrices.downTrans;
      // labelResults.graphic_list = _.remove(labelResults.graphic_list, (l) => {
      //   if (l.graphic_type === 'point' && l.group_type === 'PanoramaPoint') {
      //     return false;
      //   }
      //   return true;
      // });

      panoramaList.forEach((p) => {
        if (!p.visible) return;
        const g = labelResults.graphic_list.find(l => l.graphic_type === 'point' && l.property.type === '91' && l.property.pano_id === p.id);
        if (!g) {
          const point = new Point(null, p.x, p.y);
          labelResults.point_dict[point.uuid] = point;
          labelResults.graphic_list.unshift({
            graphic_id: point.uuid,
            graphic_type: 'point',
            graphic_data: [point.uuid],
            property: {
              type: '91',
              seq_id: p.seq_id,
              pano_id: p.id,
            },
            group_id: point.uuid,
            group_type: 'PanoramaPoint',
          });
        }
      });

      const res = [];
      labelResults.graphic_list.forEach((q) => {
        if (res.find(s => s.graphic_id === q.graphic_id && s.graphic_type === q.graphic_type)) {
          return;
        }
        res.push(q);
      });
      labelResults.graphic_list = res;

      return labelResults;
    },
    changeFloor(floor) {
      this.$router.push({
        path: `/map/newMapRouter?place_id=${this.placeId}&floor_id=${floor.id}`,
      });
      // window.location.href = ;
      window.location.reload();
    },
    resizeHandler() {
      this.konvaStage.resize();
    },
    onValueChanged(e, id) {
      if (this.target) {
        const k = {
          graphic_id: id || this.target.graphic_id,
          property: e,
        };
        this.konvaStage.updateGraphic(k);
      }
    },
    // 测试路线
    testPath() {
      const { point_dict, graphic_list } = this.konvaStage.exportData();
      const lines = graphic_list.filter(d => d.graphic_type === 'line');
      console.log(Util.findShortestPath('ee441fae', '3a65d249', point_dict, lines));
    },
    vr_viewCloce() {
      this.vrViewVisible = false;
      if (this.vrViewStage) {
        this.vrViewStage.dispose();
        this.vrViewStage = null;
        console.log('初始化vr完成');
      }
    },
    async initViewStage() {
      if (!this.floor.vr_id) return;
      if (this.vrViewStage) return;
      this.vrViewStage = new OwllyStage({
        container: this.$refs.vrViewContainer,
        vrId: this.floor.vr_id,
        panoramaList: this.panoramaList,
        modelPath: this.modelPath,
        initialView: this.initialView,
        listeners: {
          onMoveToPanorama: (pid) => {
          },
          onPanoramaCameraChanged: (p) => {
            // const euler = new THREE.Euler();
            // euler.setFromQuaternion(p, 'ZYX');
            // const radians = euler.z > 0 ?
            //   euler.z :
            //   (2 * Math.PI) + euler.z;
            // const deg = THREE.Math.radToDeg(radians);
            // this.konvaStage.updateUserPoint({
            //   rotation: this.northDegrees - deg,
            // });
          },
        },
      });
      await this.vrViewStage.init();
    },
    viewVRClear() {
      this.viewVrData = {};
    },
    // 获取路径
    async getMockData() {
      if (!this.target) return;
      this.vrViewVisible = true;
      console.log(this.target.graphic_id);
      // 选取终点
      if (this.target.property.screen_end) {
        const { point_dict, graphic_list } = this.konvaStage.exportData();
        // console.log(point_dict);
        // console.log(graphic_list);
        graphic_list.forEach((e) => {
          // eslint-disable-next-line eqeqeq
          if (e.property.pano_id == this.target.property.screen_end) {
            this.viewVrData.start = e.graphic_id; // 起点图形id
          }
        });
        const lines = graphic_list.filter(d => d.graphic_type === 'line');
        console.log('起点', this.viewVrData.start);
        console.log('终点', this.target.graphic_id);
        this.viewVrData.end = this.target.graphic_id; // 终点图形id
        this.viewVrData.pan_id = Number(this.target.property.screen_end); // 起点全景id
        const worker = new Worker();
        worker.postMessage({
          start: this.viewVrData.start,
          end: this.target.graphic_id,
          points: point_dict,
          lines,
        });
        const loading = Loading.service({
          fullscreen: true,
          text: '路网加载中...',
        });
        this.path = []; // 最短路径
        const p = new Promise((rsolve, reject) => {
          worker.onmessage = (r) => {
            console.log('最短路径', r.data);
            if (!r.data) {
              loading.close();
              this.vrViewVisible = false;
              this.$message.error('路径规划失败,请检查路网');
              reject();
              return;
            }
            this.path = r.data.map(e => ({
              id: e,
            }));
            rsolve();
          };
        });
        try {
          await p;
          this.viewVR();
          loading.close();
        } catch (error) {
          console.log(error);
        }
      }
    },
    // vr预览
    viewVR() {
      const path = this.path;
      const { point_dict, graphic_list } = this.konvaStage.exportData();
      // 根据最短路径path 图形id 获取完整数据
      graphic_list.forEach((e) => {
        path.forEach((i) => {
          if (i.id === e.graphic_id) {
            i.data = (e);
            i.data.position = point_dict[e.graphic_id];
            i.position_3d = getPositionTransform([i.data.position.x, i.data.position.y], this.cmapAlignParam.transformMatrices.upTrans);
          }
        });
      });
      console.log(path);
      if (path.length < 2) return;
      let p = [];
      this.view_id = null;
      this.arrowPoint = null;
      for (let i = path.length - 1; i >= 0; i--) {
        const e = path[i];
        if (!this.view_id) {
          if (e.data.property && e.data.property.screen_direction_pos) {
            p = e.data.property.screen_direction_pos && e.data.property.screen_direction_pos.split(';');
            const pid = e.data.property.screen_direction_pid && e.data.property.screen_direction_pid;
            if (p.length === 3 && pid == this.viewVrData.pan_id) {
              this.p = [e.position_3d.x, e.position_3d.y];
              this.view_id = e.id;
            }
            if (p.length === 3 && !pid) {
              this.p = [e.position_3d.x, e.position_3d.y];
              this.view_id = e.id;
            }
          }
        }
        if (e.data.property && e.data.property.screen_pointer && e.data.property.screen_pointer == this.viewVrData.pan_id) {
          if (!this.arrowPoint) {
            this.arrowPoint = e.position_3d;
            const n = path[i - 1];
            if (n) {
              this.nextarrowPoint = n.position_3d;
            }
          }
        }
      }
      console.log('this.view_id', this.view_id);
      console.log('可视点位', p);
      if (!this.view_id) {
        this.$message.error('未设置大屏朝向点');
        return;
      }
      if (p.length < 3) p[2] = 0;
      const v3 = new THREE.Vector3(Number(p[0]), Number(p[1]), Number(p[2]));
      v3.sub(new THREE.Vector3(this.p[0], this.p[1], this.p[2] || 0)).normalize();

      this.vrViewVisible = true;
      this.$nextTick(async () => {
        console.log('全景点', this.viewVrData.pan_id);
        await this.initViewStage();
        // eslint-disable-next-line global-require
        console.log('全景点跳转', this.viewVrData.pan_id);
        const pan = this.panoramaList.find((e) => {
          if (this.viewVrData.pan_id === e.id) return e;
        });
        if (!pan) {
          this.$message.error('全景点位不存在');
        }
        this.vrViewStage.moveToPanoramaDirection(this.viewVrData.pan_id, v3, this.sceeen_fov);
        // 添加延长线
        const pathLine = this.vrViewStage.setPath(path.map(e => ({
          x: e.position_3d.x,
          y: e.position_3d.y,
        })), arrowImg);
        const dis = pathLine.getNearestPoint(new THREE.Vector3(path[path.length - 1].position_3d.x,
          path[path.length - 1].position_3d.y, 0));
        pathLine.setCurrent(0);
        pathLine.setViewDistance(dis.distance);
        // 添加模型
        if (this.arrowPoint) {
          this.vrViewStage.showModel(this.arrowPoint, this.nextarrowPoint);
        }
      });
    },
    // 设置大屏视角
    setScreenDirection() {
      const azimuthal = this.vrViewStage.panoramaController.getAzimuthalAngle() + Math.PI / 2;
      console.log(azimuthal);
      const av2 = new THREE.Vector2(1, 0);
      av2.rotateAround(new THREE.Vector2(0, 0), azimuthal);
      const polar = this.vrViewStage.panoramaController.getPolarAngle() - Math.PI / 2;
      console.log(polar);
      const pv2 = new THREE.Vector2(1, 0);
      pv2.rotateAround(new THREE.Vector2(0, 0), polar);
      const v3 = new THREE.Vector3(av2.x, av2.y, pv2.y).normalize();
      const p = this.p;
      const x = p[0] + v3.x;
      const y = p[1] + v3.y;
      const z = v3.z;
      // this.target.property.screen_direction = `${x};${y}`;
      console.log(this.view_id);
      const { graphic_list } = this.konvaStage.exportData();
      let property = {};
      graphic_list.forEach((e) => {
        // eslint-disable-next-line eqeqeq
        if (e.graphic_id == this.view_id) { property = e.property; }
      });
      if (property.screen_direction_pos && !property.screen_direction_pid) {
        property.screen_direction = `${x.toFixed(2)};${y.toFixed(2)};${z.toFixed(2)}`;
        property.screen_direction_pos = `${x.toFixed(2)};${y.toFixed(2)};${z.toFixed(2)}`;
      } else if (property.screen_direction_pos && property.screen_direction_pid) {
        property.screen_direction = `${x.toFixed(2)};${y.toFixed(2)};${z.toFixed(2)};${property.screen_direction_pid}`;
        property.screen_direction_pos = `${x.toFixed(2)};${y.toFixed(2)};${z.toFixed(2)}`;
        property.screen_direction_pid = `${property.screen_direction_pid}`;
      }
      // if (item.length > 3) {
      //   property.screen_direction = `${x.toFixed(2)};${y.toFixed(2)};${z.toFixed(2)};${item[3]}`;
      // } else {
      //   property.screen_direction = `${x.toFixed(2)};${y.toFixed(2)};${z.toFixed(2)}`;
      // }
      const k = {
        graphic_id: this.view_id,
        property,
      };
      if (this.view_id === this.target.graphic_id) {
        this.target.property = property;
        this.targetType = 'graphic';
      }
      this.konvaStage.updateGraphic(k);
      // this.onValueChanged(this.target.property, this.view_id);
      console.log('关闭弹框');
      this.vrViewVisible = false;
    },
    queryPoint() {
      if (!this.pointId) return;
      const point = this.labelingResults.graphic_list.filter(g => g.graphic_id === this.pointId);
      console.log(point);
      if (point.length) {
        this.konvaStage.drawErrorPoints(point.map(i => i.graphic_id));
        this.konvaStage.pointFocus(point[0]);
      } else {
        this.$message.warning('未查询到点位');
      }
    },
  },
  mounted() {
    this.init();
    window.addEventListener('resize', this.resizeHandler);
  },
  beforeDestroy() {
    if (this.konvaStage) {
      this.konvaStage.dispose();
    }
    if (this.owllyStage) {
      this.owllyStage.dispose();
    }

    window.removeEventListener('resize', this.resizeHandler);
  },
};
</script>

<style lang="scss" scoped>
.wrapper {
  width: 100%;
  height: 100%;
}
.top-panel {
  width: 100%;
  height: 50px;
  background: rgba(44, 44, 46, 1);
  box-shadow: 0px 2px 4px 0px rgba(0, 0, 0, 0.1);
  border-bottom: 1px solid rgba(0, 0, 0, 1);
  color: white;
  font-size: 14px;
  display: flex;
  align-items: center;
  justify-content: center;
}
.btn {
  cursor: pointer;
  color: white;
  background: rgba(72, 72, 74, 1);
  border-radius: 4px;
  padding: 5px 15px;
  display: flex;
  align-items: center;
  line-height: 1;
  justify-content: center;
  border: 1px solid rgba(100, 100, 102, 1);
  &.active {
    background: #0884ff;
  }
}
.container-panel {
  width: 100%;
  height: calc(100% - 50px);
  display: flex;
  .left-panel {
    height: 100%;
    flex: 1;
    display: flex;
    .floors-wrapper {
      width: 140px;
      height: 100%;
      flex: 0 0 auto;
      overflow-y: auto;
      background: rgba(44, 44, 46, 1);
      .floor {
        width: 90%;
        margin: 15px 5%;
        cursor: pointer;
        color: white;
        border-radius: 4px;
        background: #3b3b3c;
        padding: 10px;
        font-size: 14px;
        &.active {
          background: rgba(8, 132, 255, 1);
        }
      }
    }
    .container-wrapper {
      flex: 1;
      height: 100%;
      background: black;
      .btns {
        height: 40px;
        display: flex;
        align-items: center;
        font-size: 12px;
        justify-content: space-between;
        padding: 0 10px;
        .left {
          display: flex;
          align-items: center;
          .btn {
            margin-right: 10px;
          }
        }
        .right {
          display: flex;
          align-items: center;
        }
      }
      .containers {
        position: relative;
        height: calc(100% - 40px);
        display: block;
        width: 100%;
        .container {
          display: block;
          float: left;
          position: relative;
          flex: 0 0 50%;
          height: 100%;
          background: white;
          .zoom-btn {
            position: absolute;
            right: 10px;
            top: 5px;
            cursor: pointer;
            z-index: 1000;
            width: 30px;
            height: 30px;
          }
          .c {
            position: relative;
            width: 100%;
            height: 100%;
          }
        }
      }
    }
  }
  .form-panel {
    background: #2c2c2e;
    color: white;
    width: 260px;
    height: 100%;
    padding: 20px;
    overflow-y: auto;
    .btn {
      font-size: 14px;
      margin-top: 20px;
    }
  }
}
.viewVRInitContent {
  background: #0884ff;
  color: #fff;
  position: fixed;
  width: 200px;
  bottom: 0;
  left: 140px;
  input {
    width: 100px;
  }
}
.vr-model {
  position: fixed;
  width: 100vw;
  height: 100vh;
  left: 0;
  top: 0;
  background: rgba(0, 0, 0, 0.3);
  z-index: 1000;
  .vr-body {
    position: absolute;
    left: 50%;
    top: 50%;
    transform: translate(-50%, -50%);
  }
}
</style>
